import React, { Fragment } from 'react';
import LoadingCard from '../loading-card/loading-card';

const StandaloneCartHistorySkeleton = ({itemsNumber = 5}) => {
      return (
            Array(itemsNumber).fill(0).map((_, key) => (
                  <div className='list-history-items-skeleton' key={key}>
                        <Fragment key={key}>
                              <LoadingCard
                                    paddingHorizontal={48}
                                    height={85}
                                    width={'100%'}
                                    borderRadius={10}
                                    marginTop={10}
                                    marginBottom={10}
                              />
                        </Fragment>
                  </div>
            ))
      )
}

export default StandaloneCartHistorySkeleton;
